import { alpha } from '@mui/material';
import theme from '@src/theme';

import { dFlex } from '@assets/mixins';

export const viewBox = {
  ...dFlex('center', 'center'),
  borderRadius: 0,
  height: 0,
  overflow: 'hidden',
  paddingBottom: '36.25%',
  position: 'relative',
  width: '65%',

  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },

  '@media (max-width: 1160px)': {
    paddingBottom: '46.25%',
  },
  '@media (max-width: 768px)': {
    paddingBottom: '52.25%',
    width: '95%',
  },
};

export const loader = {
  ...dFlex('center', 'center'),
  bottom: 0,
  left: 0,
  position: 'absolute',
  right: 0,
  top: 0,
};

export const styleBackdrop = {
  ...dFlex('center', 'center'),

  '& .MuiModal-backdrop': {
    // @ts-ignore
    background: alpha(theme.secondary.s1, 0.7),
  },
};

export const styleClose = {
  height: 32,
  position: 'absolute',
  right: 40,
  top: 40,
  width: 32,
};
